import './App.css';
import Header from './components/Header';
import Footer from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { Toaster } from 'react-hot-toast';
import Home from "./pages/Home";


function App() {
  return (
        <div className="max-w-[1680px] m-auto w-full overflow-hidden">
          <Router>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
            <Footer />
            {/*<Toaster />*/}
          </Router>
        </div>
  );
}

export default App;
